import { api } from "../api";

/**
 * updateVehicleStatusById - Function that updates on database an existing vehicle status by id  
 * /vehicles/{customerId}/{id}/{status}
 * method PUT  
 * @async-function
 */
const updateVehicleStatusById = async (token: string, id: number, customerId: number, status: string) => {
    const response = await api.put(
        `/vehicles/${customerId}/${id}/${status}`, { status }, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return response;
};

export default updateVehicleStatusById;
